module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB90CGwkJBqjcA1wAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAGHRFWHRTb2Z0d2FyZQBwYWludC5uZXQgNC4wLjOM5pdQAAAAt0lEQVRIS7WSSw7DMAgFnRP1Al3nRl01d2/0YhOgBX+wOxIbDPMix6nO9rErhJa83odZPEPovdKU+DKvpHB/Pq7i3o0W84AuOSMLZyTngC8xScqBgR+CvisXjQ78AK6bETFRC5iCr2Cx/PfnLQrwXoUOCMjd51YIB7TEYIG8vsQBnfIszsOthSG5FPfQLR8Vg6YczYgYZLkrhjQmBq6cxTNfbchnxcCU/00M1tyzIQZoUEWx9lM6AV41dADwQLHgAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./assets/icons/mining-icon.png
// module id = 497
// module chunks = 0